import axios from "axios";
import { API_URL } from "../config/env";
import { translateRefusedUpload } from "../utils/refusedUpload";

const baseURL = API_URL;

const api = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add token to requests if available (FormData needs browser-set multipart boundary)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (typeof FormData !== "undefined" && config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle response errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    translateRefusedUpload(error);
    if (error.response?.status === 401) {
      // Don't redirect on auth endpoints (signin/signup) - let them handle errors
      const isAuthEndpoint =
        error.config?.url?.includes("/auth/signin") ||
        error.config?.url?.includes("/auth/signup");

      // A 401 only means "session expired" when a token was sent; a signed-out
      // visitor browsing public pages must not be bounced to /auth.
      const headers = error.config?.headers;
      const sentToken = Boolean(headers?.Authorization || headers?.get?.("Authorization"));

      if (!isAuthEndpoint && sentToken) {
        // Token expired or invalid - only redirect if not on auth page
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Only redirect if not already on auth page
        if (window.location.pathname !== "/auth") {
          window.location.href = "/auth";
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
